import React from 'react';
import styled from 'styled-components';
import FabricItem from './FabricItem';

const Wrapper = styled.div`
  margin: 20px;
  padding: 10px;
  background: white;
  .grid-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
  }
`;

function Fabrics({ fabrics, selectedFabric, setSelectedFabric }) {
  return (
    <Wrapper>
      {fabrics.length === 0 && 'No results, please try another filter(s)!'}
      <div className="grid-wrapper">
        {fabrics.map((fabric, i) => {
          return (
            <FabricItem
              onClick={() => setSelectedFabric(fabric)}
              key={fabric.id}
              index={i}
              selected={parseInt(fabric.id) === parseInt(selectedFabric?.id)}
              fabric={fabric}
              name={fabric.name}
              collaborator={fabric.collaborator ? fabric.collaborator.name : ''}
              material={fabric.material ? fabric.material : ''}
              image={fabric.image}
            />
          );
        })}
      </div>
    </Wrapper>
  );
}

export default Fabrics;
